import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/WhatsAppFloat.css";

const WhatsAppFloat = () => {
  const phoneNumber = "916396353776"; // +91 6396353776
  const [open, setOpen] = useState(false);

  const sendMessage = (text) => {
    const message = encodeURIComponent(text);
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
    setOpen(false);
  };

  return (
    <>
      {/* MESSAGE OPTIONS */}
      {open && (
        <div className="whatsapp-popup">
          <p className="popup-title">How can we help you?</p>

          <button onClick={() =>
            sendMessage("Hi SAC MTB 👋 I want to buy a bicycle.")
          }>
            🛒 Buy a Bicycle
          </button>

          <button onClick={() =>
            sendMessage("Hi SAC MTB 👋 I need help with my order.")
          }>
            📦 Order Support
          </button>

          <button onClick={() =>
            sendMessage("Hi SAC MTB 👋 I want cycle service or repair.")
          }>
            🔧 Service / Repair
          </button>

          <button onClick={() =>
            sendMessage("🎮 Hi SAC MTB! I have a question about the Game.")
          }>
            💬 Game Enquiry
          </button>
        </div>
      )}

      {/* FLOATING ICON */}
      <button
        className="whatsapp-float"
        onClick={() => setOpen(!open)}
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </button>
    </>
  );
};

export default WhatsAppFloat;
